import { connect } from 'react-redux';
import { useEffect } from 'react';

function AdminDashboard(props) {

  useEffect(() => {
   
  }, []);

  return (
    <div style={styles.container}>
    <h1 style={styles.title}>Admin Dashboard</h1>
    <p style={styles.subtitle}>Welcome, Admin!</p>

    <div style={styles.cards}>
      <div style={styles.card}>
        <h3>Viewers Analytics</h3>
        <p>View the latest analytics from users.</p>
      </div>
      <div style={styles.card}>
        <h3>Contents Approvals</h3>
        <p>Approve or decline submitted contents.</p>
      </div>
      <div style={styles.card}>
        <h3>List of Contents</h3>
        <p>Manage all uploaded contents easily.</p>
      </div>
    </div>
  </div>
  );
}

// Simple inline styles
const styles = {
    container: {
      padding: '40px',
      textAlign: 'center',
    },
    title: {
      fontSize: '36px',
      marginBottom: '10px',
    },
    subtitle: {
      fontSize: '20px',
      color: 'gray',
      marginBottom: '30px',
    },
    cards: {
      display: 'flex',
      justifyContent: 'center',
      gap: '30px',
      flexWrap: 'wrap',
    },
    card: {
      width: '250px',
      padding: '20px',
      border: '1px solid #ccc',
      borderRadius: '12px',
      boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
      textAlign: 'left',
    },
};

// mapStateToProps (to access Redux state)
const mapStateToProps = (state) => ({
  
});

// mapDispatchToProps (to dispatch Redux actions)
const mapDispatchToProps = (dispatch) => ({
  
});

// connect to Redux
export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard);